// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__wgI8J","inputDescription":"styles_inputDescription__3pMXS"};